import { render, staticRenderFns } from "./VipDialog.vue?vue&type=template&id=4466bcf2&"
import script from "./VipDialog.vue?vue&type=script&lang=js&"
export * from "./VipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports